module.exports = __webpack_public_path__ + "img/title.a1e5d383.png";